export default __webpack_public_path__ + "static/B08-3c51becd13a4352212d623bce83330ff.png";